// Module
var code = "<div class=\"frequency-selector\"> <div class=\"btn-group btn-group-sm\"> <button class=\"btn btn-default btn-sm\" ng-repeat=\"freq in vm.frequencies\" ng-click=\"vm.click($event, freq)\" ng-class=\"{'btn-primary':vm.selectedFrequency===freq}\"> {{freq|wtFrequency}} </button> </div> </div>";
// Exports
module.exports = code;